// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lVgW","col":"styles_col__2GR0q","actions":"styles_actions__Nwgos","conflict":"styles_conflict__36Sas"};